import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export default function DetailField({ label, value, icon, action, compact = false, sx }) {
  const theme = useTheme();
  const displayValue = value === null || value === undefined || value === '' ? '-' : value;

  return (
    <Box
      sx={[
        {
          p: compact ? 1 : 1.25,
          borderRadius: theme.hr?.radius?.md || 2,
          border: '1px solid',
          borderColor: theme.hr?.line?.soft || 'divider',
          backgroundColor:
            theme.palette.mode === 'dark'
              ? alpha(theme.palette.common.white, 0.035)
              : alpha(theme.palette.primary.main, 0.025),
          minWidth: 0,
        },
        sx,
      ]}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        {icon ? (
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: theme.hr?.radius?.sm || 1.5,
              display: 'grid',
              placeItems: 'center',
              flexShrink: 0,
              color: 'primary.main',
              backgroundColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.09),
            }}
          >
            {icon}
          </Box>
        ) : null}

        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.06em' }}
          >
            {label}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.3, fontWeight: 700, overflowWrap: 'anywhere' }}>
            {displayValue}
          </Typography>
        </Box>

        {action}
      </Stack>
    </Box>
  );
}
